// extracted by mini-css-extract-plugin
module.exports = {"text":"ArticleBlock_text__wQ4tG","extra-margin":"ArticleBlock_extra-margin__JEedP"};